import React from "react";
import { format } from "date-fns";
import { fr, enCA } from "date-fns/locale";
import { Calendar as CalIcon, Clock } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

// value: "YYYY-MM-DDTHH:mm" local wall-clock string or ""; onChange(nextString)
// Always displays the Quebec/French-Canadian format jj/mm/aaaa HH:mm.
export function DateTimePicker({ value, onChange, lang = "fr", placeholder, testid }) {
  const locale = lang === "fr" ? fr : enCA;
  const date = value ? new Date(value) : undefined;
  const timeVal = value ? value.slice(11, 16) : "";

  const setDay = (day) => {
    if (!day) return;
    const t = timeVal || "00:00";
    const y = day.getFullYear();
    const m = String(day.getMonth() + 1).padStart(2, "0");
    const d = String(day.getDate()).padStart(2, "0");
    onChange(`${y}-${m}-${d}T${t}`);
  };

  const setTime = (t) => {
    const base = value ? value.slice(0, 10) : format(new Date(), "yyyy-MM-dd");
    onChange(`${base}T${t || "00:00"}`);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testid} className="bg-white sm:w-64 justify-start font-normal">
          <CalIcon className="w-4 h-4 mr-2 text-primary" />
          {date ? format(date, "dd/MM/yyyy HH:mm", { locale }) : <span className="text-slate-400">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={locale} selected={date} onSelect={setDay} initialFocus />
        <div className="flex items-center gap-2 border-t border-slate-100 p-3">
          <Clock className="w-4 h-4 text-slate-400" />
          <Input type="time" value={timeVal} onChange={(e) => setTime(e.target.value)} data-testid={testid ? `${testid}-time` : undefined} className="w-32" />
        </div>
      </PopoverContent>
    </Popover>
  );
}
